<template>
  <div class="dashboard-userinfo-block">
    <Tabs class="" :animated="false" v-if="$store.getters.userInfo.displayName" style="height:100%">
      <TabPane label="账户信息" name="basic">
        <div class="tab-content" :style="{height:tabContentHeight+'px'}">
          <vue-scroll>
            <div class="text-right">
              <Button type="primary" icon="md-create" ghost size="small" shape="circle" @click="changePwd">改密</Button>
              <Button type="error" icon="md-log-out" ghost size="small" shape="circle" style="margin-left:10px" @click="logOut">登出</Button>
            </div>
            <div class="padding-top-20"></div>
            <table class="brief-table">
              <tr>
                <td class="title">姓名</td>
                <td>{{  $store.getters.userInfo.displayName }}</td>
              </tr>
              <tr>
                <td class="title">登录用户名</td>
                <td>{{  $store.getters.userInfo.loginName }}</td>
              </tr>
              <tr>
                <td class="title">角色</td>
                <td>{{  $store.getters.userInfo.role }}</td>
              </tr>
              <tr>
                <td class="title">用户类别</td>
                <td>{{  $common.userType[$store.getters.userInfo.type] }}</td>
              </tr>
              <tr>
                <td class="title">手机号</td>
                <td>
                  <span v-if="!$store.getters.userInfo.mobile">
                    未设置手机号码
                    <Divider type="vertical" />
                    <Button type="primary" size="small" shape="circle" @click="bindMobile">去设置</Button>
                  </span>
                  <span v-else>
                    已设置
                    <Divider type="vertical" />
                    {{$store.getters.userInfo.mobile}}
                    <Divider type="vertical" />
                    <Button type="primary" size="small" shape="circle" @click="bindMobile(true)">更换</Button>
                  </span>
                </td>
              </tr>
            </table>
          </vue-scroll>
        </div>
      </TabPane>
      <TabPane label="安全设置" name="security">
        <div class="tab-content" :style="{height:tabContentHeight+'px'}">
          <vue-scroll>
            <table class="brief-table">
              <tr>
                <td class="title" width="120">CA证书</td>
                <td>
                  <Poptip transfer trigger="hover" title="证书序列号" :content="$store.getters.userInfo.certSn" v-if="$store.getters.userInfo.certSn">
                    <Tag color="green">已绑定</Tag>
                  </Poptip>
                  <Tag v-else>未绑定</Tag>
                  <Divider type="vertical" />
                  <Button type="primary" size="small" shape="circle" @click="startBinding">{{$store.getters.userInfo.certSn?'更换':'绑定'}}</Button>
                </td>
              </tr>
              <tr>
                <td class="title" width="120">印章印鉴</td>
                <td>
                  <Tag v-if="!sealImage">未设置</Tag>
                  <img :src="sealImage" width="160" v-else />
                  <Divider type="vertical" />
                  <Button type="primary" size="small" shape="circle" @click="showSealImageSetModal=true">{{$store.getters.userInfo.sealImage?'更换':'设置'}}</Button>
                </td>
              </tr>
            </table>
            <CertSelectModal :show="showCertSelectModal" :dataSigning="bindData" @cert-verified="bindSigned" @close-modal="showCertSelectModal=false" />
            <SealImageSetModal
              :show="showSealImageSetModal"
              @set-sealimage="setSealImage"
              @close-modal="showSealImageSetModal=false" />
            <Modal v-model="showBindMobileModal"
              scrollable
              :mask="true"
              :mask-closable="false"
              @on-cancel="closeBindMobile"
              title="重新绑定手机">
              <Form ref="bindMobileForm"
                label-position="left"
                :model="bindMobileModel"
                :label-width="120">
                <FormItem label="验证手机号码" prop="mobile" :rules="[{required:true,validator:validatePhone,trigger:'blur'}]">
                  <span>{{$store.getters.userInfo.mobile}}</span>
                  <Button type="primary" style="margin-left:5px" @click="sendVerifySms" :disabled="bindSmsCD">{{bindSmsCD?`${bindSmsCountDown}秒后重发`:'发送验证码'}}</Button>
                  <div class="text-grey small" v-if="bindSmsCD">验证码已发送至{{$store.getters.userInfo.mobile}},请注意查收</div>
                </FormItem>
                <FormItem label="短信验证码" prop="code" :rules="[{required:true,message:'请输入短信验证码',trigger:'blur'}]">
                  <Input v-model="bindMobileModel.code" style="width:100px" placeholder="短信验证码" />
                </FormItem>
              </Form>
              <div slot="footer">
                <Button type="primary" @click="verifyMobile">验证身份</Button>
                <Button @click="closeBindMobile">取消</Button>
              </div>
            </Modal>
          </vue-scroll>
        </div>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import SealImageSetModal from './SealImageSetModal'
import CertSelectModal from './CertSelectModal'
export default {
  components: {
    SealImageSetModal,
    CertSelectModal
  },
  data () {
    return {
      tabContentHeight: null,
      showCertSelectModal: false,
      bindData: null,
      sealImage: null,
      showSealImageSetModal: false,
      showBindMobileModal: false,
      bindMobileModel: {
        mobile: null,
        code: null
      },
      bindSmsCD: false,
      bindSmsCountDown: 60,
      bindSmsCountDownTask: null
    }
  },
  watch: {
    '$store.getters.screenHeight': function () {
      this.calcTabContentHeight()
    },
    '$store.getters.screenWidth': function () {
      this.calcTabContentHeight()
    }
  },
  mounted () {
    if (this.checkRolePermitted(['保证人'])) {
      this.getMySealImage()
    }
    this.calcTabContentHeight()
  },
  methods: {
    calcTabContentHeight () {
      if (!document.querySelector('.dashboard-userinfo-block')) {
        return false
      }
      let blockHeight = document.querySelector('.dashboard-userinfo-block').clientHeight
      this.tabContentHeight = blockHeight - 36 - 16 // 减去ivu-tab-bar高度和margin
      // console.log(blockHeight, this.tabContentHeight)
    },
    changePwd () {
      this.$emit('changePwd', false)
    },
    bindMobile (rebind = false) {
      this.$emit('bindMobile', rebind)
    },
    async logOut () {
      this.$Spin.show()
      await this.$Api.Auth(this).logout().then(() => {
        this.$Message.success('登出成功!')
        this.$Spin.hide()
        this.$store.dispatch('logout')
        this.$router.push({path: '/welcome'})
      }).catch(err => {
        this.$Spin.hide()
        this.$Notice.error({
          title: '登出失败!',
          desc: err.message
        })
        this.$store.dispatch('logout')
        this.$router.push({path: '/welcome'})
      })
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    async getMySealImage () {
      await this.$Api.Auth(this).getUserSealImage().then((data) => {
        this.sealImage = data
      })
    },
    setSealImage (img) {
      this.$Spin.show()
      this.$Api.Auth(this).setUserSealImage(img).then(() => {
        this.$nextTick(() => {
          this.$Spin.hide()
          this.showSealImageSetModal = false
          this.sealImage = img
          this.$Message.success('操作成功!')
        })
      }).catch(err => {
        console.log(err)
        this.$Spin.hide()
        this.showSealImageSetModal = false
        this.sealImage = null
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
      })
    },
    startBinding () {
      this.bindData = Math.round(Math.random() * 100000).toString()
      this.showCertSelectModal = true
    },
    async bindSigned (certSigned) {
      console.log(certSigned)
      this.$Spin.show()
      await this.$Api.Auth(this).bindCert({
        issuer: certSigned.issuer,
        certSn: certSigned.certSn,
        certBase64: certSigned.certBase64
      }).then(() => {
        this.$Message.success('绑定成功!')
        this.$Spin.hide()
      }).catch(err => {
        this.$Spin.hide()
        this.$Notice.error({
          title: '绑定失败!',
          desc: err.message
        })
      })
    },
    showBindMobile () {
      if (this.bindSmsCountDownTask) {
        clearInterval(this.bindSmsCountDownTask)
      }
      this.bindMobileModel = {
        mobile: null,
        code: null
      }
      this.bindSmsCD = false
      this.bindSmsCountDown = 60
      this.showBindMobileModal = true
    },
    closeBindMobile () {
      if (this.bindSmsCountDownTask) {
        clearInterval(this.bindSmsCountDownTask)
      }
      this.bindMobileModel = {
        mobile: null,
        code: null
      }
      this.showBindMobileModal = false
    },
    validatePhone (rule, value, callback) {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback('手机号格式不正确')
      } else {
        callback()
      }
    },
    sendVerifySms () {
      this.$Api.Auth(this).sendVerifySmsCode().then(() => {
        this.$Message.success('短信验证码发送成功')
        if (this.bindSmsCountDownTask) {
          clearInterval(this.bindSmsCountDownTask)
        }
        this.bindSmsCD = true
        this.bindSmsCountDown = 60
        this.bindSmsCountDownTask = setInterval(() => {
          if (this.bindSmsCountDown >= 1) {
            this.bindSmsCountDown--
          } else {
            this.bindSmsCountDown = 60
            this.bindSmsCD = false
            clearInterval(this.bindSmsCountDownTask)
          }
        }, 1000)
      }).catch(err => {
        this.$Message.error('短信验证码发送失败!' + err.message)
      })
    },
    async verifyMobile () {
      this.$Spin.show()
      await this.$Api.Auth(this).verifyMobile(this.bindMobileModel.mobile, this.bindMobileModel.code).then(() => {
        this.$Message.success('验证成功!')
        this.$Spin.hide()
        this.$nextTick(() => {
          this.closeBindMobile()
          this.bindMobile()
        })
      }).catch(err => {
        this.$Spin.hide()
        this.$Notice.error({
          title: '验证失败!',
          desc: err.message
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.tab-content {
  overflow: hidden;
}
.dashboard-userinfo-block {
  position: relative;
  height: 100%;
}
</style>